import React, { useState } from "react";
import { Box } from "@mui/material";
import Sidebar from "./Sidebar/Sidebar";


const Layout = ({ children }) => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

    return (
        <Box sx={{ display: "flex", minHeight: "100vh" }}>
            <Sidebar mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} />
            <Box component="main" sx={{ flexGrow: 1, padding: "1rem", width: "100%", justifyContent: "flex-start" }}>
                {children}
            </Box>
        </Box>
    );
};

export default Layout;


